import React from 'react';

const StudentPortal = () => (
  <div style={{ padding: 32 }}>
    <h2>Student Portal</h2>
    <p>This is the Student Portal page. Add your student portal features here.</p>
  </div>
);

export default StudentPortal;
